<template>
  <div
    :class="
      h5
        ? 'app mx-auto h-full relative overflow-x-hidden'
        : 'app mx-auto relative h-full desktop overflow-x-hidden'
    "
  >
    <Nav ref="nav" v-if="!(h5 || isMiniprogram)"></Nav>
    <main
      ref="main"
      :style="mainStyle"
      class="main relative clearfix h-full overflow-x-hidden"
    >
      <router-view></router-view>
    </main>
    <FooterBar ref="footer" v-if="!(h5 || isMiniprogram)"></FooterBar>
  </div>
</template>
<script>
import Nav from '@/components/common/Nav'
import FooterBar from '@/components/common/FooterBar'

export default {
  name: 'app',
  components: {
    Nav,
    FooterBar
  },
  data() {
    return {
      minHeight: null
    }
  },
  computed: {
    h5() {
      return this.$route.meta && this.$route.meta.type === 'h5'
    },
    mainStyle() {
      return this.minHeight && !this.h5 ? `min-height: ${this.minHeight}px` : ''
    },
    meta() {
      let title = this.$store.getters['HomeStore/title']
      let keywords = this.$store.getters['HomeStore/keywords']
      return { title, keywords }
    },
    isMiniprogram() {
      return (
        navigator.userAgent.match(/miniprogram/i) ||
        window.__wxjs_environment === 'miniprogram'
      )
    }
  },
  watch: {},
  mounted() {
    window.onresize = () => {
      return (() => {
        this.onWindowResized()
      })()
    }
    if (!(this.h5 || this.isMiniprogram)) {
      window.dispatchEvent(new Event('resize'))

      this.$store.dispatch('HomeStore/getHome') // 首页站点数据
      this.$store.dispatch('CategoriesStore/fetch') // nav信息
      this.$store.dispatch('CarouselsStore/fetch') // 首页轮播图
      this.$store.dispatch('SubscriberStore/fetch') // 获取个人信息
      this.$store.dispatch('PanoramasStore/fetch') // 全景
      this.$store.dispatch('SchemaConfigStore/fetch') // 获取瓷器条件
    }
    this.setmeta(this.meta)
  },
  methods: {
    // 浏览器窗体发生变化时候重新设置main的最小高度
    onWindowResized() {
      if (this.$refs.nav && this.$refs.footer && !this.h5) {
        const windowHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight
        const navHeight = this.$refs.nav.$el.offsetHeight
        const footerHeight =
          this.$refs.footer.$el.offsetHeight &&
          this.$refs.footer.$el.offsetHeight < 202
            ? 202
            : this.$refs.footer.$el.offsetHeight
        this.minHeight = windowHeight - navHeight - footerHeight
      } else {
        console.error('[App] not ready') // eslint-disable-line no-console
      }
    },
    setmeta(data) {
      if (!data.keywords) {
        return false
      }
      let head = document.getElementsByTagName('head')
      let meta = document.createElement('meta')
      meta.name = 'keywords'
      meta.content = data.keywords
      head[0].appendChild(meta)
      // document.title = data.title
    }
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 736px) {
  .app {
    &.desktop {
      min-width: 1200px;
    }
  }
}
@media only screen and (max-width: 735px) {
}
</style>
